import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "antd/dist/reset.css";
import { Auth0Provider } from "@auth0/auth0-react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import {
  AUTH_RETURN_PATH_STORAGE_KEY,
  restoreAuthReturnPath,
} from "./config/authReturnPath";
import { retryUnlessRefused } from "./console/lib/apiError";
import { setLostAnswerRefresh } from "./services/staffConfirmation/valueMovingConfirmation";

const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: retryUnlessRefused } },
});
setLostAnswerRefresh(() => {
  void queryClient.invalidateQueries();
});
const baseURL = process.env.REACT_APP_BASE_URL;
const auth0Domain = process.env.REACT_APP_AUTH_DOMAIN;
const auth0Client = process.env.REACT_APP_AUTH_CLIENT;
const auth0Audience = process.env.REACT_APP_AUTH_AUDIENCE;

const hasAuthCallbackParams = (): boolean => {
  const params = new URLSearchParams(window.location.search);
  return params.has("code") && params.has("state");
};

const clearStaleAuthTransactions = (): void => {
  if (hasAuthCallbackParams()) {
    return;
  }

  Object.keys(sessionStorage).forEach((key) => {
    if (key.startsWith("a0.spajs.txs.")) {
      sessionStorage.removeItem(key);
    }
  });
  // The pre-login deep link of an abandoned sign-in goes with its stale
  // transaction: it can hold an /accept-invite link and its one-time token.
  sessionStorage.removeItem(AUTH_RETURN_PATH_STORAGE_KEY);
};

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("Root element not found");
}

const root = ReactDOM.createRoot(rootElement);
clearStaleAuthTransactions();
root.render(
  <Auth0Provider
    domain={auth0Domain} //"auth.80eight.io" //*/"dev-fu88hpvhk3wk7i2x.us.auth0.com"
    clientId={auth0Client} /*"K9SNRi1sQUdhcuWinNANIQdbknipyuD0"//*/ //"BdKIK1lRYdsWJyx2d80vtNsOfULtJk18"
    onRedirectCallback={restoreAuthReturnPath}
    authorizationParams={{
      audience: auth0Audience /*"https://auth.80eight.io/api/v2/", //*/, //"https://dev-fu88hpvhk3wk7i2x.us.auth0.com/api/v2/",
      scope: "openid profile email",
      redirect_uri: baseURL || window.location.origin,
    }}
  >
    <QueryClientProvider client={queryClient}>
      <App />
      <ToastContainer />
      {/* {process.env.NODE_ENV === 'development' && <ReactQueryDevtools />} */}
    </QueryClientProvider>
  </Auth0Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(undefined);
